(function() {
  if (window.__tscRitualHelperLoaded) {
    return;
  }

  window.__tscRitualHelperLoaded = true;

  var giftingFallbackRoute = '/collections/gift-boxes';
  var maxGiftBudget = 220;
  var romanticOnlyHandles = [
    'valentines-tray',
    'valentines-self-care-box',
    'valentines-gift-box-for-her'
  ];
  var forHimAllowedHandles = [
    'gentlemansdailyritual',
    'moodcandlecollection',
    'gift-box-for-men',
    'complete-face-rejuvenation',
    'hair-care-luxuries',
    'mens-essential-bundle'
  ];
  var giftProducts = [
    { title: "Luxury Women's Grooming Gift Set – The Sol Kissed Daily Ritual", handle: "solkisseddailyritual", price: 150, recipients: ["for-her"], relationships: ["wife-partner", "sister", "friend", "mom", "not-sure"], priority: 5, reason: "A polished women’s grooming ritual gift with a premium self-care feel." },
    { title: "Luxury Men's Grooming Gift Set – The Gentleman's Daily Ritual", handle: "gentlemansdailyritual", price: 150, recipients: ["for-him"], relationships: ["husband-partner", "dad", "brother", "friend", "not-sure"], priority: 5, reason: "A refined men’s grooming gift set for everyday personal care." },
    { title: "Luxury Self-Care Ritual Box", handle: "luxselfcareritualbox", price: 135, recipients: ["for-her"], relationships: ["wife-partner", "sister", "friend", "mom", "not-sure"], priority: 5, reason: "A complete self-care ritual box with broad gifting appeal." },
    { title: "Luxury Care Ritual Box", handle: "luxcarebox", price: 135, recipients: ["for-her"], relationships: ["wife-partner", "sister", "brother", "friend", "mom", "dad", "not-sure"], priority: 5, reason: "A versatile care ritual box suitable for thoughtful everyday gifting." },
    { title: "The Skin Concept Mood Candle Collection", handle: "moodcandlecollection", price: 100, recipients: ["for-her", "for-him"], relationships: ["wife-partner", "husband-partner", "sister", "brother", "friend", "mom", "dad", "not-sure"], priority: 3, reason: "A mood-setting candle collection that works well as an elegant gift." },
    { title: "The Skin Concept Indulgence Candle Collection", handle: "indulgencecandlecollection", price: 100, recipients: ["for-her"], relationships: ["wife-partner", "husband-partner", "sister", "brother", "friend", "mom", "dad", "not-sure"], priority: 3, reason: "A warm indulgent candle collection for a simple premium gift." },
    { title: "Gift Box for Her", handle: "valentines-gift-box-for-her", price: 150, recipients: ["for-her"], relationships: ["wife-partner"], priority: 2, reason: "A curated gift box designed especially for her." },
    { title: "Valentine's Self Care Box", handle: "valentines-self-care-box", price: 150, recipients: ["for-her"], relationships: ["wife-partner"], priority: 2, reason: "A romantic self-care gift option for a wife or partner." },
    { title: "Valentine's Tray", handle: "valentines-tray", price: 55, recipients: ["for-her"], relationships: ["wife-partner"], priority: 2, reason: "A sweet romantic gift with strong visual appeal." },
    { title: "Gift Box for Men", handle: "gift-box-for-men", price: 225, recipients: ["for-him"], relationships: ["husband-partner", "dad", "brother", "friend", "not-sure"], priority: 4, reason: "A curated gift box made for men’s self-care." },
    { title: "Gift Box for Moms", handle: "gift-box-for-moms-to-be", price: 235, recipients: ["for-her"], relationships: ["mom"], priority: 4, reason: "A thoughtful premium gift option designed for mothers." },
    { title: "Gift Box for Children", handle: "gift-box-for-children", price: 155, recipients: ["for-kids"], relationships: [], priority: 4, reason: "A child-friendly gift box made for younger recipients." },
    { title: "Self Care Box", handle: "self-care-box", price: 175, recipients: ["for-her"], relationships: ["wife-partner", "husband-partner", "sister", "brother", "friend", "mom", "dad", "not-sure"], priority: 4, reason: "A broad self-care gift box with strong all-round appeal." },
    { title: "Gift Box for Her", handle: "gift-box-for-new-moms", price: 175, recipients: ["for-her"], relationships: ["mom"], priority: 4, reason: "A premium gift box suited for new moms and nurturing self-care." },
    { title: "Summer Self Care Box", handle: "diwali-gift-box", price: 155, recipients: ["for-her", "for-kids"], relationships: ["wife-partner", "sister", "friend", "mom", "not-sure"], priority: 4, reason: "A cheerful self-care box that works well for bright seasonal gifting." },
    { title: "Christmas Box", handle: "christmas-box", price: 190, recipients: ["for-her"], relationships: ["wife-partner", "husband-partner", "sister", "brother", "friend", "mom", "dad", "not-sure"], priority: 4, reason: "A festive gift box for seasonal self-care gifting." },
    { title: "Jamaican Bath Bundle", handle: "jamaican-bundle", price: 85, recipients: ["for-her"], relationships: ["husband-partner", "dad", "brother", "friend", "not-sure"], priority: 3, reason: "An affordable bath bundle with a fresh, vibrant feel." },
    { title: "Spiced Orange Bath Bundle", handle: "spicy-orange-bundle", price: 85, recipients: ["for-her"], relationships: ["husband-partner", "dad", "brother", "friend", "not-sure"], priority: 3, reason: "A warm, practical bath bundle suited to men’s gifting." },
    { title: "Mango Passion Bath Bundle", handle: "mango-passion-whipped-bundle", price: 85, recipients: ["for-her", "for-kids"], relationships: ["sister", "friend", "not-sure"], priority: 3, reason: "A bright, playful bath bundle that works well for casual gifting." },
    { title: "Twigs and Berries Bath Bundle", handle: "twigs-and-berries-bundle-1", price: 85, recipients: ["for-her"], relationships: ["sister", "friend", "not-sure"], priority: 3, reason: "A reliable bath bundle for friendly and casual gifting." },
    { title: "Amethyst Bath Bundle", handle: "amethyst-bundle-1", price: 85, recipients: ["for-her", "for-kids"], relationships: ["sister", "friend", "not-sure"], priority: 3, reason: "An affordable bath bundle with strong gifting appeal." },
    { title: "Caramel Popcorn Bath Bundle", handle: "caramel-popcorn-bundle", price: 85, recipients: ["for-her", "for-kids"], relationships: ["sister", "friend", "not-sure"], priority: 3, reason: "A fun gourmand bath bundle for playful gifting." },
    { title: "Lime Verbena Bath Bundle", handle: "lime-verbena-bundle", price: 85, recipients: ["for-her", "for-kids"], relationships: ["sister", "friend", "not-sure"], priority: 3, reason: "A fresh, easy-to-gift bath bundle at an accessible price." },
    { title: "Body Care Delight Bundle", handle: "body-care-delight", price: 132, recipients: ["for-her"], relationships: ["wife-partner", "mom", "not-sure"], priority: 3, reason: "A body-care gift for soft, everyday self-care." },
    { title: "Complete Face Rejuvenation Bundle", handle: "complete-face-rejuvenation", price: 138, recipients: ["for-her", "for-him"], relationships: ["wife-partner", "husband-partner", "mom", "dad", "brother", "friend", "not-sure"], priority: 3, reason: "A skincare-focused gift for someone who values face-care routines." },
    { title: "Hair Care Luxury Bundle", handle: "hair-care-luxuries", price: 165, recipients: ["for-her", "for-him"], relationships: ["wife-partner", "husband-partner", "mom", "dad", "brother", "friend", "not-sure"], priority: 3, reason: "A focused hair-care gift for someone who enjoys grooming rituals." },
    { title: "Bath Essentials Bundle", handle: "bath-essential", price: 170, recipients: ["for-her"], relationships: ["wife-partner", "husband-partner", "mom", "dad", "not-sure"], priority: 3, reason: "A practical bath-care gift for everyday use." },
    { title: "Men's Essential Bundle", handle: "mens-essential-bundle", price: 119, recipients: ["for-him"], relationships: ["husband-partner", "dad", "brother", "friend", "not-sure"], priority: 3, reason: "A practical essentials bundle for men." }
  ];
  var relationshipMap = {
    'for-her': {
      title: 'Who is she to you?',
      options: [
        { value: 'mom', label: 'Mom' },
        { value: 'wife-partner', label: 'Wife / Partner' },
        { value: 'sister', label: 'Sister' },
        { value: 'friend', label: 'Friend' },
        { value: 'not-sure', label: 'Not Sure' }
      ]
    },
    'for-him': {
      title: 'Who is he to you?',
      options: [
        { value: 'dad', label: 'Dad' },
        { value: 'husband-partner', label: 'Husband / Partner' },
        { value: 'brother', label: 'Brother' },
        { value: 'friend', label: 'Friend' },
        { value: 'not-sure', label: 'Not Sure' }
      ]
    }
  };
  var labelMap = {
    recipient: {
      'for-her': 'For Her',
      'for-him': 'For Him',
      'for-kids': 'For Kids'
    },
    relationship: {
      'mom': 'Mom',
      'wife-partner': 'Wife / Partner',
      'sister': 'Sister',
      'friend': 'Friend',
      'not-sure': 'Not Sure',
      'dad': 'Dad',
      'husband-partner': 'Husband / Partner',
      'brother': 'Brother'
    },
  };
  function initRitualHelper(root) {
    if (!root || root.hasAttribute('data-ritual-panel-initialized')) {
      return;
    }

    root.setAttribute('data-ritual-panel-initialized', 'true');

    var overlay = root.querySelector('[data-ritual-overlay]');
    var panel = root.querySelector('[data-ritual-panel]');
    var triggers = panel && panel.id ? document.querySelectorAll('[aria-controls="' + panel.id + '"]') : [];
    var closeButton = root.querySelector('[data-ritual-close]');
    var destinationButtons = root.querySelectorAll('[data-ritual-destination]');
    var backButtons = root.querySelectorAll('[data-ritual-back]');
    var recipientButtons = root.querySelectorAll('[data-ritual-recipient]');
    var budgetSlider = root.querySelector('[data-budget-slider]');
    var budgetLabel = root.querySelector('[data-budget-label]');
    var budgetContinueButton = root.querySelector('[data-budget-continue]');
    var budgetModeButtons = root.querySelectorAll('[data-budget-mode]');
    var budgetSliderWrap = root.querySelector('[data-budget-slider-wrap]');
    var relationshipTitle = root.querySelector('[data-ritual-relationship-title]');
    var relationshipOptions = root.querySelector('[data-ritual-relationship-options]');
    var recommendationsContainer = root.querySelector('[data-ritual-recommendations]');
    var recommendationSummary = root.querySelector('[data-ritual-summary]');
    var recommendationBudgetNote = root.querySelector('[data-ritual-budget-note]');
    var productBank = root.querySelector('[data-ritual-product-bank]');
    var viewAllButton = root.querySelector('[data-ritual-view-all]');
    var startOverButton = root.querySelector('[data-ritual-start-over]');
    var steps = {};
    var lastTrigger = null;
    var previousBodyOverflow = '';
    var previousHtmlOverflow = '';
    var transitionTimer = null;
    var overlayTimer = null;
    var recommendationFocusTimer = null;
    var currentStepKey = 'main';
    var productTemplateIndex = {};
    var giftingState = {
      recipient_type: '',
      relationship_type: '',
      budgetMode: 'fixed',
      maxBudget: 150
    };

    root.querySelectorAll('[data-ritual-step]').forEach(function(step) {
      steps[step.getAttribute('data-ritual-step')] = step;
    });

    Object.keys(steps).forEach(function(key) {
      var heading = steps[key].querySelector('[data-ritual-heading]');

      if (heading && !heading.id) {
        heading.id = 'tsc-ritual-heading-' + (root.getAttribute('data-ritual-section-id') || 'default') + '-' + key;
      }
    });

    if (!overlay || !panel || !triggers.length || !steps.main || !steps.self || !steps['gift-recipient'] || !steps['gift-relationship'] || !steps['gift-budget'] || !steps['gift-results']) {
      return;
    }

    hydrateProductPricesFromDom();

    function getFocusableElements() {
      return Array.prototype.slice.call(panel.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function(element) {
        return !element.hidden && element.offsetParent !== null;
      });
    }

    function syncAriaLabel(stepElement) {
      var heading = stepElement.querySelector('[data-ritual-heading]');

      if (heading && heading.id) {
        panel.setAttribute('aria-labelledby', heading.id);
      }
    }

    function focusStep(stepElement) {
      var heading = stepElement.querySelector('[data-ritual-heading]');

      syncAriaLabel(stepElement);

      if (heading) {
        heading.focus();
      }
    }

    function finishStepState(activeStep, inactiveStep) {
      activeStep.hidden = false;
      inactiveStep.hidden = true;
      activeStep.classList.add('is-active');
      inactiveStep.classList.remove('is-active', 'is-transitioning-in', 'is-transitioning-out');
      activeStep.classList.remove('is-transitioning-in', 'is-transitioning-out');
    }

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function hydrateProductPricesFromDom() {
      if (!productBank) {
        return;
      }

      productBank.querySelectorAll('[data-product-handle]').forEach(function(template) {
        var handle = template.getAttribute('data-product-handle');
        var price = Number(template.getAttribute('data-product-price'));

        if (!handle) {
          return;
        }

        productTemplateIndex[handle] = template;

        giftProducts.forEach(function(product) {
          if (product.handle === handle && !Number.isNaN(price)) {
            product.price = price;
          }
        });
      });
    }

    function getRenderableGiftProducts() {
      return giftProducts.filter(function(product) {
        return !!productTemplateIndex[product.handle];
      });
    }

    function getMaxAllowedPrice(state) {
      if (!state || state.budgetMode !== 'fixed') return Infinity;

      var target = Number(state.maxBudget);

      if (Number.isNaN(target) || target <= 0) return Infinity;

      return target * 1.3;
    }

    function isWithinPriceCeiling(product, state) {
      if (!state || state.budgetMode !== 'fixed') return true;

      var price = Number(product.price);
      var maxAllowedPrice = getMaxAllowedPrice(state);

      if (Number.isNaN(price)) return false;

      return price <= maxAllowedPrice;
    }

    function getPriceFitScore(product, state) {
      if (!state || state.budgetMode === 'flexible') {
        return 0;
      }

      var price = Number(product.price);
      var target = Number(state.maxBudget);
      var difference;
      var ratioDifference;
      var score = 0;

      if (Number.isNaN(price) || Number.isNaN(target) || target <= 0) {
        return 0;
      }

      difference = Math.abs(price - target);
      ratioDifference = difference / target;

      if (ratioDifference <= 0.10) {
        score += 12;
      } else if (ratioDifference <= 0.25) {
        score += 9;
      } else if (ratioDifference <= 0.40) {
        score += 5;
      } else {
        score -= 4;
      }

      if (price < target * 0.50) {
        score -= 8;
      }

      if (price < target * 0.35) {
        score -= 12;
      }

      return score;
    }

    function isRomanticOnlyProduct(product) {
      return romanticOnlyHandles.indexOf(product.handle) !== -1;
    }

    function isRomanticRelationship(relationshipType) {
      return relationshipType === 'wife-partner';
    }

    function isProductAllowedForRelationship(product, relationshipType) {
      if (isRomanticOnlyProduct(product)) {
        return isRomanticRelationship(relationshipType);
      }

      return true;
    }

    function isAllowedForSelectedRecipient(product, recipientType) {
      if (recipientType === 'for-him') {
        return forHimAllowedHandles.indexOf(product.handle) !== -1;
      }

      return product.recipients && product.recipients.indexOf(recipientType) !== -1;
    }

    function getRelationshipAllowedProducts(state) {
      return getRenderableGiftProducts().filter(function(product) {
        return isProductAllowedForRelationship(product, state.relationship_type);
      });
    }

    function getProductPath(handle) {
      return '/products/' + handle;
    }

    function buildFallbackRecommendationCard(product) {
      return (
        '<article class="tsc-ritual-product-card tsc-ritual-product-card--fallback">' +
          '<h4 class="tsc-ritual-product-heading"><a href="' + escapeHtml(getProductPath(product.handle)) + '">' + escapeHtml(product.title) + '</a></h4>' +
          '<p class="tsc-ritual-product-reason">' + escapeHtml(product.reason) + '</p>' +
          '<a class="Button Button--secondary tsc-ritual-option" href="' + escapeHtml(getProductPath(product.handle)) + '">View Gift</a>' +
        '</article>'
      );
    }

    function getProgressLabel(stepKey) {
      var isKids = giftingState.recipient_type === 'for-kids';

      if (stepKey === 'gift-recipient') return isKids ? 'Step 1 of 3' : 'Step 1 of 4';
      if (stepKey === 'gift-relationship') return 'Step 2 of 4';
      if (stepKey === 'gift-budget') return isKids ? 'Step 2 of 3' : 'Step 3 of 4';
      if (stepKey === 'gift-results') return isKids ? 'Step 3 of 3' : 'Step 4 of 4';
      return '';
    }

    function updateProgress(stepKey) {
      var step = steps[stepKey];
      var progress = step ? step.querySelector('[data-ritual-progress]') : null;

      if (progress) {
        progress.textContent = getProgressLabel(stepKey);
      }
    }

    function renderRelationshipOptions() {
      var relationshipConfig = relationshipMap[giftingState.recipient_type];

      if (!relationshipConfig || !relationshipTitle || !relationshipOptions) {
        return;
      }

      relationshipTitle.textContent = relationshipConfig.title;
      relationshipOptions.innerHTML = relationshipConfig.options.map(function(option) {
        return '<button type="button" class="Button Button--secondary tsc-ritual-option" data-ritual-relationship="' + escapeHtml(option.value) + '">' + escapeHtml(option.label) + '</button>';
      }).join('');
    }

    function calculateGiftScore(product, state) {
      var recipientType = state.recipient_type;
      var relationshipType = state.relationship_type;
      var score = 0;

      if (product.recipients && product.recipients.indexOf(recipientType) !== -1) {
        score += 20;
      } else {
        score -= 100;
      }

      if (
        relationshipType &&
        relationshipType !== 'not-sure' &&
        product.relationships &&
        product.relationships.indexOf(relationshipType) !== -1
      ) {
        score += 15;
      }

      if (
        relationshipType &&
        relationshipType !== 'not-sure' &&
        product.relationships &&
        product.relationships.length > 0 &&
        product.relationships.indexOf(relationshipType) === -1
      ) {
        score -= 4;
      }

      score += getPriceFitScore(product, state);

      if (typeof product.priority === 'number') {
        score += product.priority;
      }

      return score;
    }

    function formatBudgetSummary(state) {
      if (!state || state.budgetMode === 'flexible') {
        return 'No fixed budget';
      }

      return 'Around AED ' + Math.min(Number(state.maxBudget || 150), maxGiftBudget);
    }

    function scoreAndSortProducts(products, state) {
      return products.map(function(product) {
        var scoredProduct = Object.assign({}, product);
        scoredProduct._score = calculateGiftScore(product, state);
        return scoredProduct;
      }).sort(function(a, b) {
        if (b._score !== a._score) return b._score - a._score;

        if (state && state.budgetMode === 'fixed') {
          var target = Number(state.maxBudget);
          var aDistance = Math.abs(Number(a.price) - target);
          var bDistance = Math.abs(Number(b.price) - target);

          if (aDistance !== bDistance) return aDistance - bDistance;
        }

        return Number(b.priority || 0) - Number(a.priority || 0);
      });
    }

    function getGiftRecommendations(state) {
      hydrateProductPricesFromDom();

      var selectedRecipient = state.recipient_type;
      var selectedRelationship = state.relationship_type;
      var relationshipAllowedProducts = getRelationshipAllowedProducts(state);
      var recipientMatches = relationshipAllowedProducts.filter(function(product) {
        return isAllowedForSelectedRecipient(product, selectedRecipient);
      });

      if (state.budgetMode === 'fixed') {
        recipientMatches = recipientMatches.filter(function(product) {
          return isWithinPriceCeiling(product, state);
        });
      }

      var relationshipMatches = recipientMatches.filter(function(product) {
        if (!selectedRelationship || selectedRelationship === 'not-sure') return true;
        return product.relationships && product.relationships.indexOf(selectedRelationship) !== -1;
      });
      var pool = relationshipMatches.length >= 3 ? relationshipMatches : recipientMatches;
      var recommendations = scoreAndSortProducts(pool, state).slice(0, 3);

      if (recommendations.length < 3) {
        var additional = scoreAndSortProducts(recipientMatches, state)
          .filter(function(product) {
            return !recommendations.some(function(selected) {
              return selected.handle === product.handle;
            });
          });

        recommendations = recommendations.concat(additional).slice(0, 3);
      }

      return recommendations;
    }

    function renderRecommendations() {
      var recommendations = getGiftRecommendations(giftingState);
      var summaryParts = [labelMap.recipient[giftingState.recipient_type]];
      var renderedCount = 0;
      if (giftingState.recipient_type !== 'for-kids' && giftingState.relationship_type) {
        summaryParts.push(labelMap.relationship[giftingState.relationship_type]);
      }

      summaryParts.push(formatBudgetSummary(giftingState));
      recommendationSummary.textContent = summaryParts.join(' • ');
      if (recommendationBudgetNote) {
        recommendationBudgetNote.hidden = true;
      }

      recommendationsContainer.innerHTML = '';

      if (!recommendations.length) {
        recommendationsContainer.innerHTML =
          '<div class="tsc-ritual-empty">' +
            '<h4 class="tsc-ritual-empty-title">No exact match in this edit yet</h4>' +
            '<p class="tsc-ritual-empty-copy">We couldn’t find a strong match within this budget. Try widening your budget slightly, or browse the full gift edit.</p>' +
            '<div class="tsc-ritual-empty-actions">' +
              '<button type="button" class="Button Button--secondary tsc-ritual-option" data-ritual-adjust-budget>Adjust Budget</button>' +
              '<button type="button" class="Button Button--primary tsc-ritual-option" data-ritual-view-all>View All Gifts</button>' +
              '<button type="button" class="Button Button--secondary tsc-ritual-option" data-ritual-start-over-inline>Start Over</button>' +
            '</div>' +
          '</div>';
        return;
      }

      recommendations.forEach(function(product) {
        var template = productTemplateIndex[product.handle];
        var clone;
        var reasonSlot;

        if (!template) {
          console.warn('Missing Shopify product card for handle:', product.handle);
          recommendationsContainer.insertAdjacentHTML('beforeend', buildFallbackRecommendationCard(product));
          renderedCount += 1;
          return;
        }

        clone = template.cloneNode(true);
        clone.hidden = false;
        clone.classList.remove('tsc-ritual-product-template');
        reasonSlot = clone.querySelector('[data-reason-slot]');

        if (reasonSlot) {
          reasonSlot.textContent = product.reason;
        }

        recommendationsContainer.appendChild(clone);
        renderedCount += 1;
      });

      if (recommendationBudgetNote && renderedCount < recommendations.length) {
        recommendationBudgetNote.textContent = 'Some recommended products are currently unavailable.';
        recommendationBudgetNote.hidden = false;
      }
    }

    function resetSession() {
      giftingState = {
        recipient_type: '',
        relationship_type: '',
        budgetMode: 'fixed',
        maxBudget: 150
      };
      currentStepKey = 'main';
      recommendationsContainer.innerHTML = '';
      recommendationSummary.textContent = '';
      if (recommendationBudgetNote) {
        recommendationBudgetNote.hidden = true;
      }
    }

    function getFirstInteractive(stepElement) {
      return stepElement.querySelector('button:not([disabled]), [href]');
    }

    function showStep(stepKey, immediate) {
      var activeStep = steps[stepKey];
      var inactiveStep = steps[currentStepKey];

      window.clearTimeout(transitionTimer);
      window.clearTimeout(recommendationFocusTimer);

      if (!activeStep) {
        return;
      }

      currentStepKey = stepKey;
      updateProgress(stepKey);

      if (immediate) {
        Object.keys(steps).forEach(function(key) {
          steps[key].hidden = key !== stepKey;
          steps[key].classList.toggle('is-active', key === stepKey);
          steps[key].classList.remove('is-transitioning-in', 'is-transitioning-out');
        });
        window.requestAnimationFrame(function() {
          focusStep(activeStep);
        });
        return;
      }

      if (!inactiveStep || inactiveStep === activeStep) {
        showStep(stepKey, true);
        return;
      }

      activeStep.hidden = false;
      activeStep.classList.add('is-active', 'is-transitioning-in');
      inactiveStep.classList.add('is-transitioning-out');

      window.requestAnimationFrame(function() {
        activeStep.classList.remove('is-transitioning-in');
      });

      transitionTimer = window.setTimeout(function() {
        finishStepState(activeStep, inactiveStep);
        recommendationFocusTimer = window.setTimeout(function() {
          focusStep(activeStep);
          var firstInteractive = getFirstInteractive(activeStep);
          if (firstInteractive) {
            firstInteractive.focus();
          }
        }, 20);
      }, 240);
    }

    function openPanel(trigger) {
      lastTrigger = trigger || document.activeElement;
      overlay.hidden = false;
      overlay.offsetHeight;
      overlay.classList.add('is-visible');
      resetSession();
      showStep('main', true);

      previousBodyOverflow = document.body.style.overflow;
      previousHtmlOverflow = document.documentElement.style.overflow;
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';

      window.clearTimeout(overlayTimer);
      window.requestAnimationFrame(function() {
        overlayTimer = window.setTimeout(function() {
          panel.focus();
          var firstInteractive = getFirstInteractive(steps.main);
          if (firstInteractive) {
            firstInteractive.focus();
          } else {
            focusStep(steps.main);
          }
        }, 180);
      });
    }

    function closePanel() {
      if (overlay.hidden) {
        return;
      }

      window.clearTimeout(transitionTimer);
      window.clearTimeout(overlayTimer);
      window.clearTimeout(recommendationFocusTimer);
      overlay.classList.remove('is-visible');
      resetSession();
      showStep('main', true);
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;

      window.setTimeout(function() {
        overlay.hidden = true;
        if (lastTrigger && typeof lastTrigger.focus === 'function') {
          lastTrigger.focus();
        }
      }, 280);
    }

    function routeTo(path) {
      window.location.href = path;
    }

    function handleBudgetBack() {
      if (giftingState.recipient_type === 'for-kids') {
        showStep('gift-recipient');
        return;
      }

      showStep('gift-relationship');
    }

    function handleResultsBack() {
      showStep('gift-budget');
    }

    function updateBudgetUI() {
      var isFlexible = giftingState.budgetMode === 'flexible';
      var currentBudget = Math.min(Number(giftingState.maxBudget || 150), maxGiftBudget);

      giftingState.maxBudget = currentBudget;

      if (budgetSlider) {
        budgetSlider.disabled = isFlexible;
        budgetSlider.max = maxGiftBudget;
        budgetSlider.value = currentBudget;
      }

      if (budgetLabel) {
        budgetLabel.textContent = isFlexible
          ? 'No fixed budget'
          : 'Around AED ' + currentBudget;
      }

      if (budgetContinueButton) {
        budgetContinueButton.textContent = isFlexible
          ? 'Show Gift Picks'
          : 'Show Gifts Around AED ' + currentBudget;
      }

      if (budgetSliderWrap) {
        budgetSliderWrap.classList.toggle('is-disabled', isFlexible);
      }

      Array.prototype.forEach.call(budgetModeButtons, function(button) {
        button.classList.toggle(
          'is-active',
          button.getAttribute('data-budget-mode') === giftingState.budgetMode
        );
      });
    }

    function initBudgetStep() {
      if (budgetSlider) {
        budgetSlider.addEventListener('input', function(event) {
          giftingState.budgetMode = 'fixed';
          giftingState.maxBudget = Number(event.target.value);
          updateBudgetUI();
        });
      }

      Array.prototype.forEach.call(budgetModeButtons, function(button) {
        button.addEventListener('click', function() {
          giftingState.budgetMode = button.getAttribute('data-budget-mode');

          if (giftingState.budgetMode === 'fixed' && !giftingState.maxBudget) {
            giftingState.maxBudget = 150;
          }

          if (giftingState.budgetMode === 'fixed') {
            giftingState.maxBudget = Math.min(Number(giftingState.maxBudget || 150), maxGiftBudget);
          }

          updateBudgetUI();
        });
      });

      if (budgetContinueButton) {
        budgetContinueButton.addEventListener('click', function() {
          renderRecommendations();
          showStep('gift-results');
        });
      }

      updateBudgetUI();
    }

    Array.prototype.forEach.call(triggers, function(trigger) {
      trigger.addEventListener('click', function(event) {
        event.preventDefault();
        openPanel(trigger);
      });
    });

    if (closeButton) {
      closeButton.addEventListener('click', closePanel);
    }

    overlay.addEventListener('click', function(event) {
      if (event.target === overlay) {
        closePanel();
      }
    });

    panel.addEventListener('click', function(event) {
      event.stopPropagation();
    });

    panel.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closePanel();
        return;
      }

      if (event.key !== 'Tab') {
        return;
      }

      var focusableElements = getFocusableElements();

      if (!focusableElements.length) {
        return;
      }

      var firstElement = focusableElements[0];
      var lastElement = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-ritual-action]'), function(button) {
      button.addEventListener('click', function() {
        var action = button.getAttribute('data-ritual-action');

        if (action === 'open-self') {
          showStep('self');
        }

        if (action === 'open-gifting') {
          showStep('gift-recipient');
        }
      });
    });

    Array.prototype.forEach.call(destinationButtons, function(button) {
      button.addEventListener('click', function() {
        routeTo(button.getAttribute('data-ritual-destination'));
      });
    });

    Array.prototype.forEach.call(backButtons, function(button) {
      button.addEventListener('click', function() {
        var target = button.getAttribute('data-ritual-back');

        if (target === 'main') {
          showStep('main');
        } else if (target === 'recipient') {
          showStep('gift-recipient');
        } else if (target === 'budget') {
          handleBudgetBack();
        } else if (target === 'results') {
          handleResultsBack();
        }
      });
    });

    Array.prototype.forEach.call(recipientButtons, function(button) {
      button.addEventListener('click', function() {
        giftingState.recipient_type = button.getAttribute('data-ritual-recipient');
        giftingState.relationship_type = '';
        giftingState.budgetMode = 'fixed';
        giftingState.maxBudget = 150;
        updateBudgetUI();

        if (giftingState.recipient_type === 'for-kids') {
          showStep('gift-budget');
          return;
        }

        renderRelationshipOptions();
        showStep('gift-relationship');
      });
    });

    relationshipOptions.addEventListener('click', function(event) {
      var button = event.target.closest('[data-ritual-relationship]');

      if (!button) {
        return;
      }

      giftingState.relationship_type = button.getAttribute('data-ritual-relationship');
      giftingState.budgetMode = 'fixed';
      giftingState.maxBudget = 150;
      updateBudgetUI();
      showStep('gift-budget');
    });

    if (viewAllButton) {
      viewAllButton.addEventListener('click', function() {
        routeTo(giftingFallbackRoute);
      });
    }

    if (startOverButton) {
      startOverButton.addEventListener('click', function() {
        resetSession();
        updateBudgetUI();
        showStep('main');
      });
    }

    recommendationsContainer.addEventListener('click', function(event) {
      var adjustBudgetButton = event.target.closest('[data-ritual-adjust-budget]');
      var inlineStartOverButton = event.target.closest('[data-ritual-start-over-inline]');
      var inlineViewAllButton = event.target.closest('[data-ritual-view-all]');

      if (adjustBudgetButton) {
        showStep('gift-budget');
        return;
      }

      if (inlineStartOverButton) {
        resetSession();
        updateBudgetUI();
        showStep('main');
        return;
      }

      if (inlineViewAllButton) {
        routeTo(giftingFallbackRoute);
      }
    });

    initBudgetStep();
  }

  function bootRitualHelpers() {
    document.querySelectorAll('[data-ritual-root]').forEach(function(root) {
      initRitualHelper(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootRitualHelpers);
  } else {
    bootRitualHelpers();
  }
})();
